import { render, staticRenderFns } from "./OrderMiniCard.vue?vue&type=template&id=b4dbf124&scoped=true"
import script from "./OrderMiniCard.vue?vue&type=script&lang=js"
export * from "./OrderMiniCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dbf124",
  null
  
)

export default component.exports